import axios from 'axios';
import { PAGOS_VENTAS } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* 🔹 Balance del cliente: resumen (deuda/pagado/saldo) + ventas con status_pago + historial de pagos.
   Es la fuente de datos de la pestaña de pagos de DetalleCliente; tras cualquier alta/edición/eliminación
   de un pago se vuelve a pedir para que el resumen y el status por venta queden siempre recalculados. */
export const obtenerBalance = (id_cliente) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id_cliente });

    try {
        await dispatch({ type: PAGOS_VENTAS.BALANCE_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_ventas/balance`, body, config);

        await dispatch({
            type: PAGOS_VENTAS.BALANCE,
            payload: {
                cliente: res.data?.cliente || null,
                resumen: res.data?.resumen || null,
                ventas: res.data?.ventas || [],
                pagos: res.data?.pagos || []
            }
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al obtener el balance del cliente', 'danger'));
        return false;
    }
};

export const limpiarBalance = () => dispatch => {
    dispatch({ type: PAGOS_VENTAS.LIMPIAR_BALANCE });
};

export const crearPago = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_cliente: data.id_cliente || '',
        fecha: data.fecha || null,
        monto: data.monto ?? '',
        moneda: data.moneda !== undefined && data.moneda !== null ? Number(data.moneda) : 0,
        tipo_cambio: data.tipo_cambio ? Number(data.tipo_cambio) : 1,
        metodo_pago: data.metodo_pago || '',
        referencia: data.referencia || null,
        observaciones: data.observaciones || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_ventas/crear`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo registrar el pago', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Pago registrado correctamente', 'success'));

        await dispatch(obtenerBalance(data.id_cliente));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al registrar el pago', 'danger'));
        return false;
    }
};

export const editarPago = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id: data.id || '',
        fecha: data.fecha || null,
        monto: data.monto ?? '',
        moneda: data.moneda !== undefined && data.moneda !== null ? Number(data.moneda) : 0,
        tipo_cambio: data.tipo_cambio ? Number(data.tipo_cambio) : 1,
        metodo_pago: data.metodo_pago || '',
        referencia: data.referencia || null,
        observaciones: data.observaciones || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_ventas/editar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar el pago', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Pago editado correctamente', 'success'));

        await dispatch(obtenerBalance(data.id_cliente));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar el pago', 'danger'));
        return false;
    }
};

export const eliminarPago = (id, id_cliente) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_ventas/eliminar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar el pago', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Pago eliminado correctamente', 'success'));

        await dispatch(obtenerBalance(id_cliente));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_VENTAS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar el pago', 'danger'));
        return false;
    }
};
